import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { freight } from "../lib/freightApi.js";
import { T, sans } from "./ui.jsx";

/**
 * The staff area's door in the app. ⛔ THE SERVER IS THE GATE (every /api/staff route answers 403
 * staff_only to anyone else); this only spares a carrier's person a screen of refusals.
 */
export default function RequireStaff({ children, initialMe }) {
  const [me, setMe] = useState(initialMe);
  useEffect(() => {
    if (initialMe !== undefined) return undefined;
    let alive = true;
    freight.me().then((m) => alive && setMe(m)).catch(() => alive && setMe(null));
    return () => { alive = false; };
  }, [initialMe]);
  if (me?.staff) return children;
  return (
    <div style={{ fontFamily: sans, background: T.wash, minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", padding: 22 }}>
      <div style={{ maxWidth: 380, background: "#fff", border: `1px solid ${T.hair}`, borderRadius: 12, padding: 26, fontSize: 14, lineHeight: 1.5 }}>
        {me === undefined ? "Checking…" : <>This area is for MuleWorks staff. <Link to="/" style={{ color: T.ink }}>Back to Alfred</Link></>}
      </div>
    </div>
  );
}
